import { ERECUEST_STATUS } from "@src/shared/types/enums";
import pandingStatus from "@src/shared/assets/pandingStatus.png";
import errorStatus from "@src/shared/assets/errorStatus.png";
import CheckIcon from "@mui/icons-material/Check";
import SearchOffIcon from "@mui/icons-material/SearchOff";

import styles from "./styles.module.scss";

interface IRequestStatus {
  status: string;
}

export const RequestStatus = ({ status }: IRequestStatus) => {
  const renderStatus = () => {
    switch (status) {
      case ERECUEST_STATUS.DONE:
        return (
          <div className={styles.requestStatusWrap}>
            <div className={styles.requestStatusText}>Успешно</div>
            <div className={styles.fulfilledStatusWrapper}>
              {<CheckIcon sx={{ color: "white" }} />}
            </div>
          </div>
        );
      case ERECUEST_STATUS.PANDING:
        return (
          <div className={styles.requestStatusWrap}>
            <div className={styles.requestStatusText}>В работе</div>
            <div>{<img src={pandingStatus} />}</div>
          </div>
        );
      case ERECUEST_STATUS.ERROR:
        return (
          <div className={styles.requestStatusWrap}>
            <div className={styles.requestStatusText}>Ошибка запроса</div>
            <div>{<img src={errorStatus} />}</div>
          </div>
        );
      case ERECUEST_STATUS.NO_CANDIDATES:
        return (
          <div className={styles.requestStatusWrap}>
            <div className={styles.requestStatusText}>Кандидаты не найдены</div>
            <div className={styles.notFoundStatusWrapper}>
              {
                <SearchOffIcon
                  sx={{ color: "white", width: "30px", height: "30px" }}
                />
              }
            </div>
          </div>
        );
      case ERECUEST_STATUS.HH_TOKENS_EXHAUSTED:
        return (
          <div className={styles.requestStatusWrap}>
            <div className={styles.requestStatusText}>Ошибка запроса</div>
            <div>{<img src={errorStatus} />}</div>
          </div>
        );
      default:
        return (
          <div className={styles.requestStatusText}>
            Статус запроса не определен
          </div>
        );
    }
  };

  return <>{renderStatus()}</>;
};
